import http from '../common/http'

//页面查询
export const list = (param) =>{
  return http.requestPost('/resource/list',param);
}
//
export const count = (param) =>{
  return http.requestPost('/resource/count',param);
}
//获取表的所有字段
export const cols = (param) =>{
  return http.requestPost('/resource/cols',param);
}

//update
export const update = (param) =>{
  return http.requestPost('/resource/update',param);
}
//del
export const del = (param) =>{
  return http.requestPost('/resource/del',param);
}
